<template>
  <multiselect ref="inner" v-bind="$attrs" class="woot-multiselect" v-on="$listeners">
    <template v-for="(_, name) in $slots" :slot="name">
      <slot :name="name" />
    </template>
    <template v-for="(_, name) in $scopedSlots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
::v-deep {
  &.woot-multiselect {
    &.multiselect {
      .multiselect__content {
        .multiselect__option.multiselect__option--selected,
        .multiselect__option.multiselect__option--highlight:hover,
        .multiselect__option.multiselect__option--selected.multiselect__option--highlight:hover {
          @apply bg-[#F0FDF4];

          span {
            @apply text-[#164B35];
          }

          &::after {
            @apply bg-[#F0FDF4];
          }
        }
      }

      .multiselect__option.multiselect__option--selected {
        &:after {
          background-image: url(/images/checked.svg);
          width: 11px;
          height: 8px;
          background-origin: content-box;
          background-position-x: center;
          background-repeat: no-repeat;
          background-size: 11px 8px;
          top: 50%;
          transform: translateY(-50%);
          right: 12px;
          padding: 0;
        }
      }

      .multiselect__tag-icon {
        &:hover::after {
          @apply text-green-500;
        }
        &::after {
          @apply text-slate-500 leading-[26px];
        }
      }

      .multiselect__select {
        width: 9px;
        margin-right: 12px;
        min-height: 44px;
        &:before {
          border: none;
          background-image: url(/images/arrow-down.svg);
          background-origin: content-box;
          background-position-x: center;
          background-repeat: no-repeat;
          background-size: 9px 6px;
          width: 9px;
          height: 6px;
          display: block;
          position: absolute;
          top: 2px;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto 0;
        }
      }

      &.multiselect--active {
        .multiselect__select {
          transform: scaleY(-1);
        }

        &:not(.multiselect--above) .multiselect__current,
        &:not(.multiselect--above) .multiselect__input,
        &:not(.multiselect--above) .multiselect__tags {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        &.multiselect--above .multiselect__current,
        &.multiselect--above .multiselect__input,
        &.multiselect--above .multiselect__tags {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        &.multiselect--above .multiselect__content-wrapper,
        .multiselect__content-wrapper {
          border-radius: 8px;
          margin-top: 4px;
          border-color: #9ca3af;
        }

        .multiselect__tags {
          @apply border-[#9CA3AF];
        }

        .multiselect__input {
          height: 42px !important;
          line-height: 42px;
          font-size: 16px;
          &::placeholder {
            font-size: 16px;
          }
        }

        &.multiselect--above {
          .multiselect__content-wrapper {
            border-radius: 8px;
            margin-bottom: 4px;
            border-color: #9ca3af;
            overflow: hidden;
          }
        }
      }

      .multiselect__tags {
        @apply min-h-[44px] border-gray-300 hover:border-gray-400 rounded-[8px] pl-3;
        @apply max-h-[180px] overflow-y-auto flex flex-col justify-center;

        .multiselect__input {
          height: 42px !important;
          line-height: 42px;
          font-size: 16px;
          &::placeholder {
            font-size: 16px;
          }
        }
        .multiselect__tag {
          @apply my-[1px] mr-1;
        }

        .multiselect__placeholder {
          @apply text-base m-0 p-0 leading-[42px] text-gray-800;
        }

        .multiselect__tags-wrap {
          @apply m-0 flex flex-row flex-wrap gap-[2px] items-center py-[2px];
        }
      }

      .multiselect__single {
        @apply py-2.5 px-0;
      }

      .multiselect__element {
        .multiselect__option {
          @apply py-0 flex flex-col justify-center items-start h-[44px] text-base;
        }
        .multiselect__option--disabled.multiselect__option--group {
          @apply text-sm font-semibold;
          color: #9CA3AF !important;
          background-color: white !important;
        }
      }

      .multiselect__content-wrapper {
        border-end-start-radius: 8px;
        border-end-end-radius: 8px;

        &::-webkit-scrollbar {
          width: 3px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          @apply bg-gray-300 rounded-full;
        }

        &::-webkit-scrollbar-thumb:hover {
          @apply bg-gray-400;
        }
      }
    }
  }
}
</style>
<style lang="scss">
[dir='rtl'] {
  .woot-multiselect {
    &.multiselect {
      .multiselect__option.multiselect__option--selected {
        &::after {
          right: unset;
          left: 12px;
        }
      }

      .multiselect__select {
        margin-right: unset;
        margin-left: 13px;

        &::before {
          right: unset !important;
        }
      }

      .multiselect__tags {
        padding-right: 12px;
        padding-left: 40px;

        .multiselect__tag {
          @apply mr-0 ml-1 pr-[10px] pl-[24px];

          .multiselect__tag-icon {
            margin-right: 7px;
            margin-left: 0;
            left: 0;
            right: unset;
          }
        }
      }
    }
  }
}
</style>
